import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=1ff577f0"
import script from "./MobileView.ts?vue&type=script&lang=ts&external"
export * from "./MobileView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports